<template>
  <div class="select-main" @click="selectShow('main');">
    <div class="content">
      <input
        type="text"
        ref="select"
        @focus="selectFocus"
        @blur="selectBlur">
      <slot name="input"/>
     <i class="iconfont iconchevron-down" :class="[show ? 'active' : '']"></i>
    </div>
    <div :class="['main', position]" v-show="show" @click="selectShow" :style="{position}">
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'selectBox',
  props: {
    position: {
      type: String,
      default: 'absolute'
    }
  },
  data() {
    return {
      show: false,
      run: false,
    };
  },
  methods: {
    selectShow(type) {
      if (type === 'main' && this.show) {
        // this.$refs.select.blur();
        return false;
      }
      this.$refs.select.focus();

    },
    selectFocus() {
      this.show = true;
      clearTimeout(this.run);
    },
    selectBlur() {
      this.run = setTimeout(() => {
        this.show = false;
      }, 200);
    }
  }
}
</script>
<style lang="scss" scoped>
  .select-main {
    width: 100%;
    transition: all .3s ease;
    
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    position: relative;
    .iconchevron-down {
      font-size: 20px;
      display: block;
      position: absolute;
      top: 50%;
      right: 24px;
      margin-top: -10px;
      transform-origin: 50% 50%;
      transition: all .3s ease;
      color: #404040;
      &.active {
        transform: rotate(180deg);
      }
    }
    .content {
      width: 100%;
      height: 42px;
      border: 1px solid #CECECE;
      border-radius: 4px;
      position: relative;
      display: flex;
      align-items: center;
    }
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 0;
      border: none;
    }
    .main {
      width: 100%;
      max-height: 300px;
      min-height: 100px;
      border: 1px solid #CECECE;
      border-radius: 4px;
      background: #fff;
      
      margin-top: 6px;
      overflow: hidden;
      &.absolute {
        position: absolute;
        // left: -1px;
        left: 0;
        bottom: -8px;
        z-index: 9;
        transform: translateY(100%);
      }
    }
  }
</style>